<template>
  <div class="index-contact-info-component app-flex-row-space-between">
    <div class="left">
      <div class="form app-flex-row">
        <div class="form-item" :class="{ 'is-focus': focusScope == 'company' }">
          <input
            v-model="form.company"
            v-validate="{
              required: companyRule,
              isCompany: companyRule
            }"
            name="company"
            type="text"
            placeholder="公司名称（必填）"
            autocomplete="off"
            :data-vv-validate-on="validateEvents"
            :class="{
              'error-input': errorBag.has('company'),
              disabled: form.type != 1
            }"
            :disabled="form.type != 1"
            @focus="() => onFocus('company')"
            @blur="onBlur"
          />
          <div v-if="companyRule" class="error font-14 font-color-danger">
            {{ errorBag.first('company') }}
          </div>
          <div
            class="personal font-14 item-text app-flex-row"
            @click="toggleType"
          >
            <i
              class="iconfont"
              :class="[
                form.type == 1
                  ? 'icon-weixuan1'
                  : 'icon-yixuan font-color-primary'
              ]"
            ></i>
            个人用户
          </div>
        </div>
        <div
          class="form-item"
          :class="{ 'is-focus': focusScope == 'username' }"
        >
          <input
            v-model="form.name"
            v-validate="'required|isName'"
            name="username"
            type="text"
            placeholder="姓名（必填）"
            autocomplete="off"
            :data-vv-validate-on="validateEvents"
            :class="{ 'error-input': errorBag.has('username') }"
            @focus="() => onFocus('username')"
            @blur="onBlur"
          />
          <div class="error font-14 font-color-danger">
            {{ errorBag.first('username') }}
          </div>
        </div>
        <div class="form-item" :class="{ 'is-focus': focusScope == 'userTel' }">
          <input
            v-model="form.phone"
            v-validate="'required|isPhone'"
            name="userTel"
            type="text"
            placeholder="手机号（必填）"
            autocomplete="off"
            :data-vv-validate-on="validateEvents"
            :class="{ 'error-input': errorBag.has('userTel') }"
            @focus="() => onFocus('userTel')"
            @blur="onBlur"
          />
          <div class="error font-14 font-color-danger">
            {{ errorBag.first('userTel') }}
          </div>
        </div>
        <div
          class="form-item"
          :class="{ 'is-focus': focusScope == 'userEmail' }"
        >
          <input
            v-model="form.email"
            v-validate="'required|isEmail'"
            name="userEmail"
            scope="email"
            type="text"
            placeholder="邮箱（必填）"
            autocomplete="off"
            :data-vv-validate-on="validateEvents"
            :class="{ 'error-input': errorBag.has('userEmail') }"
            @focus="() => onFocus('userEmail')"
            @blur="onBlur"
          />
          <div class="error font-14 font-color-danger">
            {{ errorBag.first('userEmail') }}
          </div>
        </div>
      </div>
      <div class="submit-box">
        <p v-if="totalError" class="total-error font-color-danger">
          {{ totalError }}
        </p>
        <div
          class="submit font-color-white app-flex-row-center"
          @click="handleSubmit"
        >
          {{ submitText }}
        </div>
      </div>
    </div>
    <div class="right app-flex-column">
      <span class="label">或者直接拨打</span>
      <i class="line"></i>
      <h3 class="tel font-42 font-color-primary">4000-970-970</h3>
      <span class="time font-14 font-color-desc">9:00~18:00 (周一到周五)</span>
    </div>

    <modal-base
      v-if="successShow"
      bg-color="rgba(0,0,0,0.45)"
      :lock-scroll="false"
      @wrapper-click="successShow = false"
    >
      <div class="success-box app-flex-column">
        <div class="icon-box">
          <i class="iconfont icon-chenggong font-color-white font-64"></i>
        </div>
        <p class="font-24 font-color-primary title">信息已提交成功</p>
        <p>请保持电话畅通</p>
        <p>您的专属顾问会在1个工作日内联系您</p>
        <div class="close-btn app-flex-row-center font-color-white">
          <i class="iconfont icon-guanbianniu" @click="successShow = false"></i>
        </div>
      </div>
    </modal-base>
  </div>
</template>

<script>
import { Validator } from 'vee-validate/dist/vee-validate.minimal.esm'
import { required } from 'vee-validate/dist/rules.esm'
import { API_PATH } from '@/global/config'

const EXP_PATTERN = {
  // 手机
  phone: /^1\d{10}$/,
  email: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
  min: 2,
  max: 30
}

Validator.extend('required', required)

Validator.extend('isCompany', {
  validate: value => {
    let length = String(value).length
    return EXP_PATTERN.min <= length && length <= EXP_PATTERN.max
  }
})

Validator.extend('isName', {
  validate: value => {
    let length = String(value).length
    return EXP_PATTERN.min <= length && length <= EXP_PATTERN.max
  }
})

Validator.extend('isPhone', {
  getMessage: () => '手机号格式错误',
  validate: value => EXP_PATTERN.phone.test(value)
})

Validator.extend('isEmail', {
  validate: value => EXP_PATTERN.email.test(value)
})

Validator.localize('zh_CN', {
  custom: {
    company: {
      required: '请您填写公司名称',
      isCompany: '公司名称限2-30个字符'
    },
    username: {
      required: '请您填写姓名',
      isName: '姓名限2-30个字符'
    },
    userTel: {
      required: '请您填写手机号',
      isPhone: '手机号格式错误'
    },
    userEmail: {
      required: '请您填写邮箱',
      isEmail: '邮箱格式错误'
    }
  }
})

export default {
  components: {
    ModalBase: () => import('@/components/common/ModalBase')
  },
  props: {
    submitText: {
      type: String,
      default: '立即预约咨询'
    },
    from: {
      type: String,
      default: 'index'
    }
  },
  inheritAttrs: false,
  data() {
    return {
      form: {
        from: this.from,
        company: '',
        name: '',
        // 类型(0:个人,1:公司)
        type: 1,
        terminal: 'pc',
        phone: '',
        email: ''
      },
      companyRule: true,
      submitting: false,
      successShow: false,
      totalError: '',
      validateEvents: 'change',
      focusScope: ''
    }
  },
  mounted() {},
  methods: {
    toggleType() {
      this.companyRule = this.form.type != 1
      this.form = {
        ...this.form,
        type: this.form.type == 1 ? 0 : 1,
        company: ''
      }
    },
    handleSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.doSubmit()
        }
      })
    },
    async doSubmit() {
      this.validateEvents = ''
      if (this.submitting) {
        return
      }
      this.submitting = true
      try {
        const res = await this.$http.post(API_PATH.Comm_Consult.receive, {
          data: {
            ...this.form,
            source: document.cookie
              .split(';')
              .map(item => item.trim())
              .reduce(
                (p, c) =>
                  c.indexOf('fr=') === 0 ? c.substring(3, c.length) : p,
                ''
              )
          }
        })
        const { errno, error } = res
        if (errno == 0) {
          this.successShow = true
          setTimeout(() => {
            this.validateEvents = 'change|custom'
          }, 500)
          this.resetForm()
        } else {
          this.totalError = error
        }
        this.submitting = false
      } catch {
        this.submitting = false
      }
    },
    resetForm() {
      this.form = {
        company: '',
        name: '',
        type: 1,
        phone: '',
        email: ''
      }
    },
    onFocus(name) {
      this.totalError = ''
      this.focusScope = name
      this.validateEvents = 'change'
    },
    onBlur() {
      this.focusScope = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.index-contact-info-component {
  align-items: flex-start;
  .left {
    width: 816px;
    .form {
      .form-item {
        width: 380px;
        margin-right: 28px;
        margin-bottom: 50px;
        position: relative;
        input {
          box-sizing: border-box;
          width: 100%;
          border-radius: 26px;
          border: 1px solid $neutral-color-3;
          padding: 15px 24px;
          outline: none;
          margin-bottom: 8px;
          &.error-input {
            border-color: $danger-color;
          }
          &::-webkit-input-placeholder {
            /* WebKit browsers */
            font-size: 14px;
            color: $text-color-desc;
          }

          &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            font-size: 14px;
            color: $text-color-desc;
          }

          &:-ms-input-placeholder {
            /* Internet Explorer 10+ */
            font-size: 14px;
            color: $text-color-desc;
          }

          &:focus {
            border-color: $primary-color;
          }

          &.disabled {
            background-color: $text-color-other;
            border-color: $text-color-other;
            cursor: not-allowed;
            &::-webkit-input-placeholder {
              /* WebKit browsers */
              font-size: 14px;
              color: $text-color-notice;
            }

            &::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              font-size: 14px;
              color: $text-color-notice;
            }

            &:-ms-input-placeholder {
              /* Internet Explorer 10+ */
              font-size: 14px;
              color: $text-color-notice;
            }
          }
        }
        .error {
          position: absolute;
          left: 24px;
          top: -4px;
          transform: translateY(-100%);
        }
        .personal {
          position: absolute;
          left: 24px;
          top: 60px;
          cursor: pointer;
          .iconfont {
            margin-right: 4px;
          }
        }
        &.is-focus {
          .error {
            display: none;
          }
        }
      }
    }
    .submit-box {
      position: relative;
      .submit {
        width: 788px;
        height: 48px;
        background: $primary-color;
        border-radius: 23px;
        cursor: pointer;
        margin-top: -10px;
      }
      .total-error {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        margin-top: -30px;
      }
    }
  }
  .right {
    align-items: flex-end;
    .line {
      width: 64px;
      height: 4px;
      background: $neutral-color-3;
      border-radius: 2px;
      margin-top: 12px;
      margin-bottom: 16px;
    }
    .tel {
      margin-bottom: 8px;
    }
  }

  .success-box {
    width: 580px;
    height: 382px;
    background: $white;
    border-radius: 8px;
    border: 1px solid $neutral-color-3;
    align-items: center;
    padding-top: 70px;
    box-sizing: border-box;
    @extend .center;
    .icon-box {
      width: 120px;
      height: 120px;
      background: rgba(42, 96, 228, 0.1);
      position: relative;
      border-radius: 50%;
      margin-bottom: 28px;
      &:after {
        content: '';
        width: 74px;
        height: 74px;
        background: $base-color-2;
        border-radius: 50%;
        @extend .center;
      }
      .iconfont {
        z-index: 9;
        @extend .center;
      }
    }
    .title {
      margin-bottom: 16px;
    }
    .close-btn {
      width: 40px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid $white;
      border-radius: 50%;
      position: absolute;
      right: 0;
      top: 0;
      margin: -40px -40px 0 0;
      cursor: pointer;
    }
  }
}
</style>
